import React from 'react';
import { Descriptions } from 'antd';
import userDateFormatter from '../../../services/formatters/userDateFormatter';

const CustomerBaseDisplayDescriptions = ({descriptionData}) => {

    const getRepresentativeName = () => {
        const representativeField = descriptionData.rp;
        return representativeField && representativeField.length
            ? `${representativeField[0].name || ''} ${representativeField[0].surname || ''}`
            : 'Kayıt Yok';
    }

    const getRepresentativePhone = () => {
        const representativeField = descriptionData.rp;
        return representativeField && representativeField.length
            ? representativeField[0].phone || ''
            : 'Kayıt Yok';
    }

    return(
        <React.Fragment>
            <Descriptions title='Müşteri Bilgileri' labelStyle={{fontWeight: 'bold'}} bordered>
                <Descriptions.Item label={'Kayıt Tarihi'}>{userDateFormatter(descriptionData.cd)}</Descriptions.Item>
                <Descriptions.Item label={'Telefonu'}>{descriptionData.p}</Descriptions.Item>
                <Descriptions.Item label={'İlgili'}>{getRepresentativeName()}</Descriptions.Item>
                <Descriptions.Item label={'İlgili Telefonu'}>{getRepresentativePhone()}</Descriptions.Item>
            </Descriptions>
        </React.Fragment>
    )
}
export default CustomerBaseDisplayDescriptions;